// Returns a size-optimized image URL when the CDN supports it.
// - Pexels: add ?auto=compress&cs=tinysrgb&w=...
// - Unsplash: add ?w=...&q=75&auto=format
// - Everything else (customer-assets, /api/media, etc.): return unchanged.
export function optimizeUrl(url, width = 1200) {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;
  try {
    const u = new URL(url, "https://x");
    const host = u.hostname;
    if (host.includes("pexels.com")) {
      u.searchParams.set("auto", "compress");
      u.searchParams.set("cs", "tinysrgb");
      u.searchParams.set("w", String(width));
      return u.toString();
    }
    if (host.includes("unsplash.com")) {
      u.searchParams.set("w", String(width));
      u.searchParams.set("q", "75");
      u.searchParams.set("auto", "format");
      u.searchParams.set("fit", "crop");
      return u.toString();
    }
    return url;
  } catch {
    return url;
  }
}

// Build a responsive srcSet for the CDNs that support width params.
export function buildSrcSet(url) {
  if (!url || typeof url !== "string") return undefined;
  if (url.startsWith("data:") || url.startsWith("blob:")) return undefined;
  try {
    const host = new URL(url, "https://x").hostname;
    if (host.includes("pexels.com") || host.includes("unsplash.com")) {
      return [400, 640, 900, 1200, 1600]
        .map((w) => `${optimizeUrl(url, w)} ${w}w`)
        .join(", ");
    }
  } catch {
    /* ignore */
  }
  return undefined;
}
